export const LField = ({ label, value, maxChars = 35, bigLabel }: LFieldProps): JSX.Element => {
    let trimmedValue = value;

    if (trimmedValue) {
        if (maxChars) {
            trimmedValue = value.slice(0, maxChars);
        }

        if (trimmedValue[trimmedValue.length - 1] === ",") {
            trimmedValue = trimmedValue.slice(0, -1);
        }

        if (value.length > 35) {
            trimmedValue = `${trimmedValue}...`;
        }
    }

    return (
        <div className="field">
            <div className="is-size-6 mb-0">{label}</div>
            <p className={`has-text-weight-bold is-size-${bigLabel ? "6" : "7"}`}>{trimmedValue}</p>
        </div>
    );
};

interface LFieldProps {
    label: string;
    value: string;
    maxChars?: number;
    bigLabel?: boolean;
}
